import React from 'react';
import { Outlet } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/theme.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* Layout is a thin wrapper — each page provides its own header/nav as needed */
const Layout = () => (
  <div style={{ minHeight: '100vh' }}>
    <Outlet />
    <ToastContainer />
  </div>
);

export default Layout;
